<template>
  <div>
    <div class="ma-0">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <div class="facility pt-1" v-on="on" v-bind="attrs">
            <div class="code">{{ segment.facility_name }}</div>
          </div>
        </template>
        <div>{{ segment.from_city }}, {{ segment.from_country }}</div>
        <div>{{ segment.address }}</div>
      </v-tooltip>
    </div>
    <div class="time-row">
      <div class="time">
        {{ formatDate(segment.from_gmt_date) }}
        <br />
        {{ formatTime(segment.from_gmt_date) }}
      </div>
      <v-icon class="icon" size="18">fas fa-arrow-right</v-icon>
      <div class="time">
        {{ formatDate(segment.to_gmt_date) }}
        <br />
        {{ formatTime(segment.to_gmt_date) }}
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  name: "TimelineSingleIata",
  props: {
    segment: {
      type: Object,
    },
  },
  methods: {
    formatDate: function (date) {
      return dayjs(date).format("MM/DD/YYYY");
    },
    formatTime: function (time) {
      return dayjs(time).format("HH:mm");
    },
  },
};
</script>

<style scoped>
.segment div {
  margin: 5px;
}

.facility {
  font-weight: 900;
  color: #313131;
  margin: 0px !important;
  text-align: center;
}

.facility .code {
  color: #1976d2;
}

.time-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 5px;
  padding-bottom: 5px;
}
.time-row .time {
  text-align: left;
  margin: 0px;
}
.time-row .time:last-child {
  text-align: right;
}

.time-row .icon {
  color: #1976d2;
}
</style>
